package com.schoolconnect.app.datasource.network.response

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class LookupItemResponse(
    val id: String? = null,
    val category: String? = null,
    val code: String? = null,
    @SerialName("display_value")
    val displayValue: String? = null,
    @SerialName("sort_order")
    val sortOrder: Int? = null,
    @SerialName("is_active")
    val isActive: Boolean? = null
)

@Serializable
data class LookupCategoryResponse(
    val category: String? = null,
    val items: List<LookupItemResponse>? = null
)
